import { render, staticRenderFns } from "./TheLottery.vue?vue&type=template&id=481f0a23&scoped=true"
import script from "./TheLottery.vue?vue&type=script&lang=js"
export * from "./TheLottery.vue?vue&type=script&lang=js"
import style0 from "./TheLottery.vue?vue&type=style&index=0&id=481f0a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f0a23",
  null
  
)

export default component.exports